import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import api from '@/api/index';

const useFederalDistricts = () => {
  const [federalDistricts, setFederalDistricts] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    let isMounted = true;

    api.get('/v1/api/map/federal-districts/', {
      headers: { 'Accept-Language': i18n.language },
    }).then(res => {
      if (isMounted && res.status === 200) {
        setFederalDistricts(res.data || []);
      }
    }).catch(() => {
      if (isMounted) setFederalDistricts([]);
    });

    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  return federalDistricts;
};

export default useFederalDistricts;
